import React, { useEffect, useState } from 'react';
import { Input, Button, Space, Table, Popconfirm, Form, FormInstance, Select } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { VariableOption } from './componentType';

const operatorOptions = [
  { label: '等于', value: '==' },
  { label: '大于', value: '>' },
  { label: '小于', value: '<' },
  { label: '不等于', value: '!=' },
];

interface Option {
  label: string;
  value: string;
}

type BranchEditorProps = {
  form: FormInstance;
  upstreamVariables?: VariableOption[];
  availableTargetNodes?: { label: string; value: string }[]; // 添加这一行
};

export default function BranchEditor({ form, upstreamVariables, availableTargetNodes }: BranchEditorProps) {
  const [nodeOption, setNodeOption] = useState<Option[]>([]);

  useEffect(() => {
    // 按节点ID分组
    const grouped: { [key: string]: VariableOption[] } = {};

    const options: Option[] = [];

    upstreamVariables?.forEach(variable => {
      const nodeId = variable.nodeId;
      if (!grouped[nodeId]) {
        grouped[nodeId] = [];
      }
      options.push({
        label: `${variable.nodeId}_${variable.variableName}`,
        value: `${variable.nodeId}_${variable.variableName}`,
      });
    });

    setNodeOption(options || []);
  }, [upstreamVariables]);

  const addBranch = () => {
    const tableData = form.getFieldValue('branches') || [];
    const newRow = {
      priority: tableData.length + 1,
    };
    form.setFieldsValue({
      branches: [...tableData, newRow],
    });
  };

  const deleteBranch = (record: any) => {
    const tableData = form.getFieldValue('branches');
    const branches = tableData.filter(item => item.priority !== record.priority);
    form.setFieldsValue({
      branches: branches,
    });
  };

  const columns = [
    {
      title: '表达式',
      dataIndex: 'expression',
      render: (_: any, record: any, index: number) => (
        <Space style={{ display: 'flex' }} size={2}>
          <Form.Item
            name={['branches', index, 'left']}
            style={{ marginBottom: 0 }}
            rules={[{ message: '请选择', required: true }]}
          >
            <Select style={{ width: 130 }} placeholder="请选择" options={nodeOption} popupMatchSelectWidth={false} />
          </Form.Item>
          <Form.Item
            name={['branches', index, 'operator']}
            style={{ marginBottom: 0 }}
            rules={[{ message: '请选择', required: true }]}
          >
            <Select style={{ width: 90 }} placeholder="请选择" options={operatorOptions} />
          </Form.Item>
          <Form.Item
            name={['branches', index, 'right']}
            style={{ marginBottom: 0 }}
            rules={[{ message: '请输入', required: true }]}
          >
            <Input style={{ width: 90 }} placeholder="请输入" />
          </Form.Item>
        </Space>
      ),
    },
    {
      title: '目标节点',
      dataIndex: 'toNodeId',
      render: (_: any, record: any, index: number) => (
        <Form.Item
          name={['branches', index, 'toNodeId']}
          style={{ marginBottom: 0 }}
          rules={[{ message: '请选择目标节点', required: true }]}
        >
          <Select
            placeholder="请选择目标节点"
            options={availableTargetNodes} // 使用传入的目标节点列表
            popupMatchSelectWidth={false}
          />
        </Form.Item>
      ),
    },
    {
      title: '操作',
      width: 60,
      render: (_: any, record: any) => (
        <Popconfirm title="确定删除此分支？" onConfirm={() => deleteBranch(record)}>
          <Button type="link" size="small" icon={<DeleteOutlined />} />
        </Popconfirm>
      ),
    },
  ];

  return (
    <div>
      <Form.Item noStyle labelAlign="left" name="branches" valuePropName="dataSource">
        <Table size="small" pagination={false} columns={columns} rowKey="toNodeId" />
      </Form.Item>
      <Space style={{ marginTop: 12 }}>
        <Button type="primary" onClick={addBranch} icon={<PlusOutlined />}>
          新增分支
        </Button>
      </Space>
    </div>
  );
}
